module.exports = __webpack_public_path__ + "img/welcome-admin.ef787b91.svg";